<script lang="js">
import { QTooltip } from 'quasar'
import { slot } from 'quasar/src/utils/slot'

export default {
  name: 'Tooltip',

  mixins: [
    QTooltip
  ],

  props: {
    anchor: {
      ...QTooltip.options.props.anchor,
      default: 'top middle'
    },
    self: {
      ...QTooltip.options.props.self,
      default: 'bottom middle'
    },
    offset: {
      ...QTooltip.options.props.offset,
      default: () => [150, 10]
    }
  },

  methods: {
    __renderPortal(h) {
      const inside = [
        ...slot(this, 'default')
      ]

      return h('transition', {
        props: { name: this.transition }
      }, [
        this.showing === true ? h('div', {
          staticClass: 'tes-tooltip q-tooltip q-tooltip--style q-position-engine no-pointer-events',
          class: this.contentClass,
          style: this.contentStyle,
          attrs: {
            role: 'complementary'
          }
        }, inside) : null
      ])
    }
  }
}
</script>

<style lang="scss">
.tes-tooltip {
  overflow: visible;
  width: 210px;
  border: 1px solid #EFF1F7;
  filter: drop-shadow(0px 3px 6px #00000029);
  background-color: currentColor;
}
</style>
